export function createFormFromFile(file) {
  const data = new FormData();
  data.append("file", file);
  return data;
}

export function createFormFromBlob(blob, type) {
  
  const data = new FormData();
  if(blob)
  {
    data.append("file", blob, type);
  }
  
  return data;
}

export const s2ab = (s) => {
  var buf = new ArrayBuffer(s.length);
  var view = new Uint8Array(buf);
  for (var i=0; i!==s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
  return buf;
}